import { render, staticRenderFns } from "./SimpleBasicInfo.vue?vue&type=template&id=85078ca4&scoped=true"
import script from "./SimpleBasicInfo.vue?vue&type=script&lang=js"
export * from "./SimpleBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./SimpleBasicInfo.vue?vue&type=style&index=0&id=85078ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85078ca4",
  null
  
)

export default component.exports